import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { AppContext } from "../App";
import Slide from "../components/Slide";
import { stripHtml, truncateText } from "../components/functions";

function Cms() {
	const { slides, pages, getTranslatedString, lang, settings } = useContext(AppContext);
	const [page, setPage] = useState(false);
	const [pageSlides, setPageSlides] = useState([]);
	let params = useParams();

	const setMetaTagContent = (name, content) => {
		if (!document?.head) return;
		let tag = document.head.querySelector(`meta[name="${name}"]`);
		if (!tag) {
			tag = document.createElement("meta");
			tag.setAttribute("name", name);
			document.head.appendChild(tag);
		}
		tag.setAttribute("content", content || "");
	};

	useEffect(() => {
		const scrollContainer = document.getElementById("main");
		scrollContainer.scrollTo(0, 0);
	}, [page, lang]);

	useEffect(() => {
		const p = pages.find((page) => page.id == params.id);
		setPage(p);
		const pageSlideIds = p?.slides?.map((ps) => ps.id) || [];
		const filteredSlides = slides.filter((s) => pageSlideIds.includes(s.id));
		setPageSlides(filteredSlides);
	}, [params, pages, slides]);

	useEffect(() => {
		const siteTitle = settings?.global?.name || "";
		if (!page) {
			document.title = siteTitle;
			setMetaTagContent("description", "");
			setMetaTagContent("keywords", "");
			return;
		}

		const pageTitle = (page.meta_title || getTranslatedString(page, "title") || "").trim();
		const pageDescription = (
			page.meta_description ||
			truncateText(stripHtml(getTranslatedString(page, "text") || ""), 160) ||
			""
		).trim();
		const pageKeywords = (page.meta_keywords || "").trim();

		document.title = pageTitle || siteTitle;
		setMetaTagContent("description", pageDescription);
		setMetaTagContent("keywords", pageKeywords);

		return () => {
			document.title = siteTitle;
		};
	}, [page, settings, getTranslatedString]);

	return (
		<div className="page">
			<h1 id="page-header">{getTranslatedString(page, "title")}</h1>
			<div className="slides">
				{pageSlides.map((slide, i) => (
					<Slide key={i} slide={slide} />
				))}
			</div>
			<div className="container">
				{page && (
					<>
						{page.img && (
							<div className="img">
								<img src={page.img} />
							</div>
						)}
						<div
							dangerouslySetInnerHTML={{ __html: getTranslatedString(page, "text") }}
						/>
					</>
				)}
			</div>
		</div>
	);
}

export default Cms;
